/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSurveyChatResult } from '../../models/get-survey-chat-result';

export interface GetChatsByResponseid$Params {
  ResponseId: number;
}

export function getChatsByResponseid(
  http: HttpClient,
  rootUrl: string,
  params: GetChatsByResponseid$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetSurveyChatResult>> {
  const rb = new RequestBuilder(rootUrl, getChatsByResponseid.PATH, 'get');
  if (params) {
    rb.path('ResponseId', params.ResponseId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSurveyChatResult>;
    }),
  );
}

getChatsByResponseid.PATH = '/Surveys/chats/{ResponseId}';
